// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { LinkFragmentDoc } from '../../../../cms/index.generated';
import { ImageLargeFragmentDoc } from '../../../../cms/imageLarge.fragment.generated';
export const SubMenuItemFragmentDoc = gql`
    fragment subMenuItem on SubMenuItem {
  title
  link {
    ...link
  }
  media {
    ...imageLarge
  }
  icon {
    ...imageLarge
  }
  style
}
    ${LinkFragmentDoc}
${ImageLargeFragmentDoc}`;